export const ELEMENT_ID = {
  LEAD_FORM: 'lead-form'
}
